import React, { useEffect } from 'react';
import { Button, Card, Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Component and Redux imports
import MainLayout from '../../components/MainLayout/MainLayout';
import ClientStatisticsCard from './components/ClientStatisticsCard/ClientStatisticsCard';
import SubscriptionManagementCard from './components/SubscriptionManagementCard/SubscriptionManagementCard';
import CustomerBasedWaterUsageTable from './components/ClientBasedWaterUsageTable/ClientBasedWaterUsageTable';
import DijikolayCustomerSummaryChart from './components/DijikolayCustomerSummaryChart/DijikolayCustomerSummaryChart';
import { useDispatch } from 'react-redux';
import {
    fetchClientBasedStatisticsRequest,
    fetchClientStatisticsRequest,
    fetchDijiKolayChartRequest,
    fetchSubscriptionManagementRequest
} from '../../redux/reducers/dashboard/dashboardSlice';

const Dashboard = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation('dashboard');
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(fetchDijiKolayChartRequest());
        dispatch(fetchClientBasedStatisticsRequest({ page: 1, limit: 5 }));
        dispatch(fetchClientStatisticsRequest());
        dispatch(fetchSubscriptionManagementRequest());
    }, [dispatch]);

    return (
        <MainLayout>
            <Row style={{ paddingBottom: 24 }} gutter={[24, 24]}>
                <Col xs={24}>
                    <Card
                        extra={
                            <Button
                                size={"middle"}
                                className='card-button-title'
                                onClick={() => navigate('/clients')}
                            >
                                {t('view_customers')}
                            </Button>
                        }
                        className="custom-card-head"
                        style={{ boxShadow: '0 4px 10px rgba(0, 0, 0, 0.25)', height: "100%" }}
                        title={<span className='base-card-header-title'>{t('customer_statistics')}</span>}
                    >
                        <ClientStatisticsCard />
                    </Card>
                </Col>
                <Col xs={12}>
                    <Card
                        className="custom-card-head"
                        style={{ boxShadow: '0 4px 10px rgba(0, 0, 0, 0.25)', height: "100%" }}
                        title={<span className='base-card-header-title'>{t('total_data_statistics')}</span>}
                    >
                        <SubscriptionManagementCard />
                    </Card>
                </Col>
                <Col xs={12}>
                    <Card
                        extra={
                            <Button
                                size={"middle"}
                                className='card-button-title'
                                onClick={() => navigate('/integrations/dijikolay')}
                            >
                                {t('view_integrations')}
                            </Button>
                        }
                        className="custom-card-head"
                        style={{ boxShadow: '0 4px 10px rgba(0, 0, 0, 0.25)', height: "100%" }}
                        title={<span className='base-card-header-title'>{t('dijikolay_customer_summary')}</span>}
                    >
                        <DijikolayCustomerSummaryChart />
                    </Card>
                </Col>
                <Col xs={24}>
                    <Card
                        bodyStyle={{ padding: "0px" }}
                        className="custom-card-head"
                        style={{ boxShadow: '0 4px 10px rgba(0, 0, 0, 0.25)', height: "100%" }}
                        title={<span className='base-card-header-title'>{t('customer_based_water_usage')}</span>}
                    >
                        <CustomerBasedWaterUsageTable />
                    </Card>
                </Col>
            </Row>
        </MainLayout>
    )
}

export default Dashboard;